var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQaAddlisting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1201",
    x: 0,
    y: 0,
    width: 186,
    height: 186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qa-add_listing",
    "data-name": "qa-add listing",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12)",
    filter: "url(#Rectangle_1201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201-2",
    "data-name": "Rectangle 1201",
    width: 150,
    height: 150,
    rx: 25,
    transform: "translate(12 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add_listing_-_large",
    "data-name": "add listing - large",
    transform: "translate(47.482 25.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(-1618.128 -215.418)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    y2: 23.828,
    transform: "translate(1685.36 215.418)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    y2: 23.72,
    transform: "translate(1697.22 227.332) rotate(90)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M28.2.707.517,26.593v37.06H20.983V43.564a7.42,7.42,0,1,1,14.84,0v20.09H55.889V26.593Z",
    transform: "translate(-0.517 22.447)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaAddlisting);
export default __webpack_public_path__ + "static/media/qa-add listing.6cc280dce3f661c6a241ded76b0b0ba8.svg";
export { ForwardRef as ReactComponent };